import { CameraHelper, Camera } from 'three';

import { Cylinder, Grid, OrbitControls, PerspectiveCamera, View, Text } from '@react-three/drei';
import { Canvas, useThree } from '@react-three/fiber';
import * as React from 'react';

function Lights() {
  return (
    <>
      <ambientLight intensity={1} />
      <pointLight position={[20, 30, 10]} />
      <pointLight position={[-10, -10, -10]} color="blue" />
    </>
  );
}

type MyDebugProps = {
  children?: React.ReactNode;
};

function HelperSetup() {
  const { scene, camera } = useThree();
  React.useEffect(() => {
    const { id, children } = scene;
    console.log(`${id} camera[${camera.id}]: ${camera.name}`);
    for (const child of children) {
      const { id, name, type } = child;
      console.log(`  - [${id}]: ${type}(${name})`);
      if (name == 'main' && child instanceof Camera) {
        scene.add(new CameraHelper(child));
      }
    }
  }, []);
  return <></>;
}

function MyDebug(props: MyDebugProps) {
  const { children } = props;
  const ref = React.useRef<HTMLDivElement>(null!);
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <div
        style={{
          display: 'flex',
          position: 'absolute',
          width: '100%',
          height: '100%',
        }}
      >
        <View index={1} className="view-1" style={{ flexGrow: 1 }}>
          {children}
          <HelperSetup />
          {/* <OrbitControls /> */}
        </View>
        <View index={2} className="view-1" style={{ flexGrow: 1 }}>
          {children}
          <HelperSetup />
          <PerspectiveCamera name="secondary" makeDefault position={[5, 5, 8]} fov={35} />
          <OrbitControls />
        </View>
      </div>
      <Canvas eventSource={ref} className="canvas">
        <View.Port />
      </Canvas>
    </div>
  );
}

export type Props = {};

// camera.setViewOffset(100, 100, 10, 10, 100, 100);

function App(props: Props) {
  const {} = props;

  return (
    <MyDebug>
      <Lights />
      <PerspectiveCamera name="main" makeDefault position={[3, 0, 5]} fov={35} />
      <Text name="hello" color="yellow">
        Hello
      </Text>
      <color attach="background" args={['#000000']} />
      {/* <mesh position={[-3, 0, 0]}>
        <boxGeometry args={[2, 2, 1]} />
        <meshBasicMaterial wireframe />
      </mesh> */}
      <mesh>
        <boxGeometry args={[2, 2, 1]} />
        <meshBasicMaterial wireframe />
      </mesh>
      <Cylinder>
        <meshBasicMaterial wireframe />
      </Cylinder>
      <Text name="hello" color="yellow">
        Hello
      </Text>
      <Grid args={[10, 10]} cellColor="white" />
    </MyDebug>
  );
}

export default React.memo(App);
